<style lang="scss" scoped>
.audit-aside{
  position: fixed;
  top:80px;
  left:0;
  width:156px;
  height:100%;
  background:#494949;
  padding-top:62px;
  .aside-list{
    .list-item{
      a{
        display:block;
        padding:15px 0 15px 24px;
        font-size:14px;
        font-weight: bold;
        color:#fff;
        letter-spacing: -0.5px;
        &.active{
          background:#4174ff;
        }
      }
    }
  }
}
</style>
<template>
<aside class="audit-aside">
  <ul class="aside-list">
    <li class="list-item" v-for="(aside, index) in this.getGroupMenuList" :key="index" v-bind:class="{ active: isActive === aside.url }">
      <a :href="aside.url"  v-bind:class="{ active: isActive === aside.url }" >{{aside.name}}</a>
    </li>
  </ul>
</aside>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
export default {
  name: 'AdminAside',
  created () {
    this.setInit()
  },
  data () {
    return {
      isActive: window.location.pathname
    }
  },
  methods: {
    ...mapActions({
      setInit: 'apiAdminGroupMenus'
    })
  },
  computed: {
    ...mapGetters(['getGroupMenuList'])
  }
}
</script>



// WEBPACK FOOTER //
// src/components/AdminAside.vue